import {css} from '../theme/css'

export const classes = {
  root: css`
    -webkit-tap-highlight-color: transparent;
  `,
  label: css`
    cursor: pointer;
  `,
}
